// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/sass/main.scss
// module id = 586
// module chunks = 1